import { render, staticRenderFns } from "./AzulCard.vue?vue&type=template&id=62902712&scoped=true"
import script from "./AzulCard.vue?vue&type=script&lang=js"
export * from "./AzulCard.vue?vue&type=script&lang=js"
import style0 from "./AzulCard.vue?vue&type=style&index=0&id=62902712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62902712",
  null
  
)

export default component.exports